import { getObjectTypedKeys, mapObjectValues } from '@augment-vir/common';
import { unsafeCSS } from 'lit';
export function hostClassNamesToStylesInput({ hostClassNames, cssVarNames, cssVarValues, }) {
    return {
        hostClassSelectors: mapObjectValues(hostClassNames, (key, name) => {
            return unsafeCSS(`:host(.${name})`);
        }),
        hostClassNames: mapObjectValues(hostClassNames, (key, name) => {
            return unsafeCSS(name);
        }),
        cssVarNames: cssVarNames,
        cssVarValues: cssVarValues,
    };
}
export function applyHostClasses({ host, hostClassesInit, hostClassNames, state, inputs, }) {
    if (!hostClassesInit) {
        return;
    }
    getObjectTypedKeys(hostClassesInit).forEach((hostClassKey) => {
        const maybeCallback = hostClassesInit[hostClassKey];
        const hostClassName = hostClassNames[hostClassKey];
        if (typeof maybeCallback === 'function') {
            const shouldApplyHostClass = maybeCallback({ state, inputs });
            if (shouldApplyHostClass) {
                host.classList.add(hostClassName);
            }
            else {
                host.classList.remove(hostClassName);
            }
        }
    });
}
